import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener('plotly_click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const logEntryId = event.detail.plotly.points[0]?.customdata?.log_entry_id;

    if (logEntryId) {
      window.location.hash = `log-entry-${logEntryId}`;
    }
  }
}
